import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { OnboardingCompanyInformation } from '@interfaces/a-organizar/onboardingCompanyInformation';
import { CompanyOnboardingRequest } from '@src/app/core/models/company-onboarding/company-onboarding-request';
import { OnboardingModule } from '@src/app/features/onboarding/onboarding.module';

@Component({
  selector: 'app-company-registration-card',
  standalone: true,
  imports: [OnboardingModule],
  templateUrl: './company-registration-card.component.html',
  styleUrls: ['./company-registration-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyRegistrationCardComponent {
  @Input() onboardingCompanyInformation: OnboardingCompanyInformation | null = null;
  @Output() saveCompanyInfo = new EventEmitter<CompanyOnboardingRequest>();
}
